import type {
  Category,
  LanguageCode,
} from "$src/core/services/search-classification/types";

// Languages the platform can translate (plus English, which needs no
// translation). Non-English queries are translated to English before the
// ExecuTorch embeddings classifier runs.
//
// iOS:     Apple Translation. Programmatic translation (TranslationSession) is
//          iOS 18+. The set grows across iOS releases, so update this as Apple
//          adds them.
// Android: Google ML Kit (59 languages), but we support the same languages as
//          iOS for now.
export const LANGUAGES = [
  "en",
  "ar",
  "zh",
  "nl",
  "fr",
  "de",
  "hi",
  "id",
  "it",
  "ja",
  "ko",
  "pl",
  "pt",
  "ru",
  "es",
  "th",
  "tr",
  "uk",
  "vi",
] as const satisfies readonly LanguageCode[];

// TODO: Make these dynamic based on CMS
export const CATEGORIES: readonly Category[] = [
  "Action & Adventure",
  "Comedy",
  "Crime & Thriller",
  "Documentary",
  "Drama",
  "Family & Animation",
  "Horror",
  "Romance",
  "Sci-Fi & Fantasy",
];
